import { render, staticRenderFns } from "./GuiaRecebimento.vue?vue&type=template&id=3d6fe908&"
import script from "./GuiaRecebimento.vue?vue&type=script&lang=js&"
export * from "./GuiaRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports